/*    
<summary>
   This typescript file contains special datatype that enables for a variale to be set of predefined enums.
   This enum is used to differentiate event types in the overall application.
   Developer: Mohammad Saquib Khan, Created Date: 20-Apr-2025 
</summary>
*/
enum EventTypeEnum {
  Appointment = 0,
  StaffBreak = 1,
}

export default EventTypeEnum;
